<template>
  <div class="drawer" v-if="curUser">
    <div class="user-avatar">
      <div v-if="curUser" class="avatar-details">
        <!-- <div class="profile-icon">
          <font-awesome-icon class="icon" icon="fa-solid fa-user"/>
        </div> -->
        <div class="user-info">
          <h5>{{ curUser.Username }}</h5>
          <p>{{ curUser.Type }}</p>
          <p>{{ defaultStore }}</p>
        </div>
      </div>
    </div>
    <div class="routes">
      <ul>
        <li v-if="isUpdateAvailable">
          <a @click="updateApp">
            <div class="icon-box">
              <font-awesome-icon class="icon text-info" icon="fa-solid fa-exclamation-circle"/>
            </div>
            <div class="d-flex flex-column text-center">
              Update Is Available
              <span class="text-sm" @click="updateApp">Click to Update</span>
            </div>
          </a>
        </li>
        <div class="box-container mt-2" v-if="isSmartInvoiceLive && shouldSmartInvoiceSignUp"
             @click="loginToOnlineBackOfficeSmartInvoice">
          <div class="box red-background-blink">
            <h6 class="route-btn w-100 bg-transparent text-white"> Smart Invoicing Sign up </h6>
          </div>
        </div>


        <li :class="hasNoFloatAssigned">
          <router-link @click.native="back" :to="{ name : 'pos' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="basket-shopping"/>
            </div>
            Sales
          </router-link>
        </li>

        <li>
          <router-link @click.native="back" :to="{ name : 'salesRecords' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-receipt"/>
            </div>
            Invoices
          </router-link>
        </li>

        <li v-if="deviceSettings && deviceSettings.layby">
          <router-link @click.native="back" :to="{ name : 'lay-by-sales' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="circle-dollar-to-slot"/>
            </div>
            Sales On LayBy
          </router-link>
        </li>
        <li v-if="isLoyaltyActivated">
          <router-link @click.native="back" :to="{ name : 'loyalty-customers' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="heart-circle-check"/>
            </div>
            Loyalty Customers
          </router-link>
        </li>

        <li>
          <a @click="loginToOnlineBackOffice">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="business-time"/>
            </div>
            Back Office (Admin)
          </a>
        </li>

        <li>
          <a @click="stockTake">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="boxes"/>
            </div>
            Stock Take
          </a>
        </li>

        <li>
          <a @click="cashup">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-coins"/>
            </div>
            End User Shift
          </a>
        </li>

        <li>
          <a @click="cashupRecords">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="magnifying-glass-chart"/>
            </div>
            Cashup Records
          </a>
        </li>

        <li>
          <a @click="ViewOpenTicket">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-receipt"/>
            </div>
            View Tickets
          </a>
        </li>
        <li>
          <a @click="TicketRoute">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-gear"/>
            </div>
            Report an Issue
          </a>
        </li>
        <li>
          <a @click="settings">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-gear"/>
            </div>
            Device Settings
          </a>
        </li>
        <li>
          <a @click="logout">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-arrow-right-from-bracket"/>
            </div>
            Log out
          </a>
        </li>
      </ul>
      <br>
      <div class="last-upd">
        Last Updated : {{ lastUpdated }}
      </div>
    </div>
  </div>

</template>

<script>
import Swal from "sweetalert2";
import {mapActions} from "vuex";
import {Storage} from "@/services/Storage";

export default {
  name: "NavigationDrawer",
  props: {
    close: {
      type: Function,
      required: true,
    }
  },
  beforeMount() {
    this.checkSmartInvoicing();
    this.validateLogin();
    auth.isStoreSelected();

  },
  computed: {
    defaultStore() {
      return this.$store.getters.getDefaultStore.StoreName
    },
    lastUpdated() {
      return this.$store.getters.getLasUpdated
    },
    curUser() {
      return this.$store.getters.getCurrentUser
    },
    deviceSettings() {
      return this.$store.getters.getDeviceSettings;
    },
    isLoyaltyActivated() {
      return this.$store.getters.getHasLoyalty;
    },
    isUpdateAvailable() {
      return this.$store.getters.getUpdateAvailability;
    },
    hasNoFloatAssigned() {
      return this.$route.name === "float" ? 'disabled' : '';
    },
    setMsg() {
      return this.curUser.Type === 'admin' ? '' : 'blocked'
    },
    shouldSmartInvoiceSignUp() {
      return !this.$store.getters.getSmartInvoicingStatus && !this.$store.getters.getDocSubmissionStatus;
    },
    isSmartInvoiceLive() {
      return this.$store.getters.getSmartInvoicingLive;
    },
  },
  methods: {
    ...mapActions(['checkSmartInvoicing']),
    async validateLogin() {
      let isLoggedIn = await auth.isCashierLoggedIn();
      if (!isLoggedIn) {
        return this.$router.push({name: 'poslogin'})
      }
    },
    async logout() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `Loggoff`);
      if (!isAllowed) return responses.showWarning('User not allowed to logout');
      if(isAllowed){
        await this.$store.dispatch('posLogout')
        this.back();
      }
    },
    async loginToOnlineBackOffice() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `Boffice`);
      if (isAllowed) await this.$store.dispatch(`openOnlineBackOffice`)
      return this.back();
    },
    async loginToOnlineBackOfficeSmartInvoice() {

      this.$store.dispatch(`openOnlineBackOffice`, {
        name: `smart-invoicing-setup`
      })
      return this.back();
    },
    back() {
      if (this.close) {
        this.close();
      } else {
 
      }
    },
    async settings() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `Settings`);
      if (isAllowed) await this.$router.push({name: `settings`})
      return this.back();
    },
    SystemSupport() {
      this.$router.push({name: `ticket`})
    },
    updateApp() {
      this.$store.commit(`setUpdateAvailability`, false);
      return window.location.reload(true);
    },
    async ViewOpenTicket() {
      this.$router.push({name: 'ViewOpenTicket'})
      this.back()
    },
    async TicketRoute() {
      this.$router.push({name: 'TicketRequest'})
      this.back()
    },
    async cashupRecords() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `cashUpReports`);
      if (isAllowed) await this.$router.push({name: `cashup-records`})
      return this.back();
    },
    async stockTake() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `StockTake`);
      if (!isAllowed) return this.back();
      const route = this.$store.getters.getStockTakeRoute;
      await this.$router.push(route);
      return this.back();
    },
    async cashup() {
      return this.$router.push({name: `cashup`})
    },
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  display: none;
}

.drawer {
  width: 100%;
  background: #ffffff;
  height: 100%;
  overflow-y: auto;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);

  .routes {
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      cursor: pointer;

      li {
        padding: 0;
        margin: 4px 0;

        a {
          height: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-weight: 500;
          padding: 0 16px;
          text-decoration: none;
          color: #2c3e50;
          border-radius: 8px;
          margin: 0 8px;
          transition: all 0.3s ease;

          .icon-box {
            width: 40px;
            height: 40px;
            margin-right: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 8px;
            background: rgba(58, 113, 232, 0.1);
            transition: all 0.3s ease;

            .icon {
              font-size: 20px;
              color: #0092f7;
              transition: all 0.3s ease;
            }
          }

          &:hover, &.router-link-exact-active {
            background: #f8f9fa;
            color: #3a71e8;
            font-weight: 600;

            .icon-box {
              background: rgba(58, 113, 232, 0.15);
              transform: scale(1.05);

              .icon {
                color: #3a71e8;
              }
            }
          }
        }
      }
    }
  }

  .user-avatar {
    display: flex;
    width: 100%;
    background: linear-gradient(135deg, #0092f7 0%, #2c3e50 100%);
    color: white;
    min-height: 140px;
    padding: 24px 16px;
    position: relative;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.1) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      transform: rotate(30deg);
      animation: shine 6s infinite;
    }

    .avatar-details {
      width: 100%;
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      gap: 16px;

      .profile-icon {
        width: 60px;
        height: 60px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid rgba(255, 255, 255, 0.3);
        backdrop-filter: blur(4px);
        
        .icon {
          font-size: 24px;
          color: white;
        }
      }

      .user-info {
        flex: 1;

        h5 {
          margin: 0 0 8px 0;
          font-size: 1.25rem;
          font-weight: 600;
          letter-spacing: 0.5px;
        }

        p {
          margin: 4px 0;
          font-size: 0.875rem;
          color: rgba(255, 255, 255, 0.9);
          font-weight: 400;

          &:nth-child(3) {
            color: #ffffff;
            font-weight: 500;
            margin-top: 12px;
            padding: 6px 16px;
            background: rgba(255, 255, 255, 0.15);
            border-radius: 20px;
            display: inline-block;
            backdrop-filter: blur(4px);
            border: 1px solid rgba(255, 255, 255, 0.2);
          }
        }
      }
    }
  }
}

.last-upd {
  font-size: 0.75rem;
  color: #6c757d;
  text-align: center;
  padding: 16px;
  margin-top: 8px;
  border-top: 1px solid #e9ecef;
}

.box-container {
  display: flex;
  justify-content: center;
  margin: 16px 8px;
}

.red-background-blink {
  background: linear-gradient(45deg, #ff4b4b, #ff6b6b);
  animation: blink 1.5s infinite;
  padding: 12px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(255, 75, 75, 0.2);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(255, 75, 75, 0.3);
  }
}

.box {
  display: inline-block;
}

.text-white {
  color: white;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

@keyframes shine {
  20% {
    transform: translateX(-100%) rotate(30deg);
  }
  30%, 60% {
    transform: translateX(100%) rotate(30deg);
  }
}
</style>
